"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var useModal = function useModal(defaultIsOpen) {
  var _useState = (0, _react.useState)(defaultIsOpen),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var open = function open() {
    setOpen(true);
  };

  var close = function close() {
    setOpen(false);
  };

  return {
    isOpen: isOpen,
    close: close,
    open: open
  };
};

var _default = useModal;
exports.default = _default;